"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var moment_1 = require("moment");
var vivien_1 = require("vivien");
var price_1 = require("./price");
function setField(store, field) {
    store.dispatch('validateField', field);
    store.dispatch('validate');
}
function validateField(store, field) {
    var rules = [];
    var allRules = store.getters['validations'];
    var pc = store.getters['paymentCountries'];
    if (allRules !== undefined && allRules[field.name]) {
        rules = allRules[field.name][0].rules;
    }
    var paxField = lodash_1.cloneDeep(store.getters[field.name]);
    if (paxField === undefined) {
        return;
    }
    paxField.value = field.value;
    paxField.valid = true;
    paxField.error = null;
    paxField.warning = null;
    if (field.name === 'zipCode') {
        var code = store.getters['postalCountryCode'].value || 'DE';
        var country = lodash_1.find(pc, ['isoCode', code]);
        rules = [
            {
                message: 'Postleitzahl ungültig',
                regex: country.zipFormat.replace(/^\//, '').replace(/\/$/, ''),
            },
        ];
    }
    if (field.name === 'postalCountryCode' && store.getters['zipCode'].touched) {
        store.commit('SET_FIELD', paxField);
        store.dispatch('validateField', {
            name: 'zipCode',
            value: store.getters['zipCode'].value,
        });
    }
    for (var _i = 0, rules_1 = rules; _i < rules_1.length; _i++) {
        var rule = rules_1[_i];
        if (paxField.error === null) {
            if ((rule.regex &&
                !rule.triggerIfMatch &&
                !new RegExp(rule.regex, 'i').test(field.value)) ||
                (rule.triggerIfMatch && new RegExp(rule.regex, 'i').test(field.value))) {
                if (rule.type === 'notice') {
                    paxField.warning = rule.message;
                }
                else {
                    paxField.valid = false;
                    paxField.error = rule.message;
                }
            }
        }
    }
    store.commit('SET_FIELD', paxField);
}
function validate(store) {
    store.commit('SET_VALID', allFieldsValid(store));
}
function mark(store) {
    var fields = store.getters['allFieldsArray'];
    for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
        var field = fields_1[_i];
        if (!field.touched) {
            store.dispatch('setField', {
                name: field.name,
                value: field.value,
            });
        }
    }
}
function importFormValidations(store, formValidations) {
    store.commit('IMPORT_FORM_VALIDATIONS', formValidations);
}
function importPaymentCountries(store, countries) {
    store.commit('IMPORT_PAYMENT_COUNTRIES', countries);
}
function setPrice(store, priceInfo) {
    var departure = moment_1.utc(priceInfo.departure, 'DD.MM.YYYY');
    var deadline = departure.subtract(30, 'days');
    var result = new price_1.Price(priceInfo.fullprice);
    var fullPrice = priceInfo.fullprice - priceInfo.insurancePrice;
    if (deadline.isSameOrAfter(moment_1.utc())) {
        result.deadline = deadline.format('DD.MM.YYYY');
        var deposit = 0;
        if (priceInfo.priceModel === 'VARIO') {
            deposit = 0.25 * fullPrice + priceInfo.insurancePrice;
        }
        else if (priceInfo.priceModel === 'PAUSCHAL') {
            deposit = 0.25 * fullPrice + priceInfo.insurancePrice;
        }
        else if (priceInfo.priceModel === 'PREMIUM' ||
            priceInfo.priceModel === 'PREMIUMAI') {
            deposit = 0.2 * fullPrice + priceInfo.insurancePrice;
        }
        else if (priceInfo.priceModel === 'JUST') {
            deposit = 0.3 * fullPrice + priceInfo.insurancePrice;
        }
        result.deposit = deposit;
        result.outstanding = priceInfo.fullprice - deposit;
    }
    store.commit('SET_PRICE', result);
}
function setCovidNote(store, value) {
    store.commit('SET_COVID_NOTE', value);
    store.dispatch('validate');
}
function setCovidNoteError(store, value) {
    store.commit('SET_COVID_NOTE_ERROR', value);
}
function setTerms(store, value) {
    store.commit('SET_TERMS', value);
    store.dispatch('validate');
}
function setTermsError(store, value) {
    store.commit('SET_TERMS_ERROR', value);
}
function setFormSheetPauschal(store, value) {
    store.commit('SET_FORM_SHEET_PAUSCHAL', value);
    store.dispatch('validate');
}
function setFormSheetPauschalError(store, value) {
    store.commit('SET_FORM_SHEET_PAUSCHAL_ERROR', value);
}
function setInsuranceBooked(store, value) {
    store.commit('SET_INSURANCE_BOOKED', value);
    store.dispatch('validate');
}
function setInsuranceTerms(store, value) {
    store.commit('SET_INSURANCE_TERMS', value);
    store.dispatch('validate');
}
function setInsuranceTermsError(store, value) {
    store.commit('SET_INSURANCE_TERMS_ERROR', value);
}
function setIppBooked(store, value) {
    store.commit('SET_IPP_BOOKED', value);
}
function setIppAccepted(store, value) {
    store.commit('SET_IPP_ACCEPTED', value);
    store.dispatch('validate');
}
function setIppError(store, value) {
    store.commit('SET_IPP_ACCEPTED_ERROR', value);
}
function fetchFormPDF(store, docId) {
    return __awaiter(this, void 0, void 0, function () {
        var content, _a, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    _a = atob;
                    return [4 /*yield*/, vivien_1.client.pdf(docId)];
                case 1:
                    content = _a.apply(void 0, [_b.sent()]);
                    store.commit('SET_FORM_PDF', content);
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _b.sent();
                    console.log(err_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.default = {
    importFormValidations: importFormValidations,
    importPaymentCountries: importPaymentCountries,
    mark: mark,
    setField: setField,
    validate: validate,
    validateField: validateField,
    setPrice: setPrice,
    setTerms: setTerms,
    setTermsError: setTermsError,
    setCovidNote: setCovidNote,
    setCovidNoteError: setCovidNoteError,
    setFormSheetPauschal: setFormSheetPauschal,
    setFormSheetPauschalError: setFormSheetPauschalError,
    setInsuranceTerms: setInsuranceTerms,
    setInsuranceTermsError: setInsuranceTermsError,
    setInsuranceBooked: setInsuranceBooked,
    setIppBooked: setIppBooked,
    setIppAccepted: setIppAccepted,
    setIppError: setIppError,
    fetchFormPDF: fetchFormPDF,
};
function allFieldsValid(store) {
    var fields = store.getters['allFieldsArray'];
    for (var _i = 0, fields_2 = fields; _i < fields_2.length; _i++) {
        var field = fields_2[_i];
        if (!field.valid) {
            return false;
        }
    }
    if (!store.getters['terms']) {
        return false;
    }
    if (!store.getters['covidNote']) {
        return false;
    }
    if (!store.getters['formSheetPauschal']) {
        return false;
    }
    if (store.getters['insuranceBooked'] && !store.getters['termsInsurance']) {
        return false;
    }
    if (store.getters['ippBooked'] && store.getters['ippAccepted'] === null) {
        return false;
    }
    return true;
}
//# sourceMappingURL=actions.js.map